import React, { useEffect, useState } from 'react';
import { Col, Row } from '../../lib/utils';
import Header from '../../components/Header';
import { Bottom } from '../global';
import { useLocation, useNavigate } from 'react-router-dom';
import { SortType } from './FeedPage';
import FeedMemberHeader from '../../components/FeedMember/FeedMemberHeader';
import RangeCalendar from '../../components/Calendar/RangeCalendar';
import { useQuery } from '@tanstack/react-query';
import { getAllCoachMemberListAPI, getUnifiedMemberFeedAPI } from '../../api/feed';
import { getItemWithExpiration } from '../../lib/utils';
import dayjs from 'dayjs';
import FeedList from '../../components/Feed/FeedList/FeedList';
import FeedTableView from '../../components/Feed/FeedTableView';
import FeedSelectList from '../../components/Feed/FeedSelectList/FeedSelectList';
import ModalFeedDetail from '../../components/Feed/ModalFeedDetail/ModalFeedDetail';
import { colors } from '../../lib/colors';
import ModalVideoPlayer from '../../components/modal/ModalVideoPlayer';
import ModalImagesViewer from '../../components/modal/ModalImagesViewer';
import BusinessInfoFooter from '../../components/BusinessInfoFooter';

let sortOptions: any = [
    { value: 'all', label: '전체보기' },
    { value: 'SCHEDULEREPORT', label: '수업 일지' },
    { value: 'coach', label: '강사 게시글' },
    { value: 'member', label: '회원 게시글' },
];

const FeedMemberPage = ({ authObject, setAuthObject, authorization }: any) => {
    const location = useLocation();
    const navigate = useNavigate();

    const limitCount = 10;
    const [lastPostId, setLastPostId] = useState<string>('');
    const [memberId, setMemberId] = useState<string>(location?.state?.memberId ? location.state.memberId : '');
    const [coachId, setCoachId] = useState<string>(location?.state?.coachId ? location?.state?.coachId : '');
    const [sortType, setSortType] = useState<SortType>({
        value: 'all',
        label: '전체 보기',
    });
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);

    const [feedList, setFeedList] = useState<any>([]); // 일지 피드 리스트
    const [centerUserList, setCenterUserList] = useState<any>([]); // 센터의 강사,회원 리스트
    const [modalObject, setModalObject] = useState<any>(null); // 상세 모달 스테이트

    const [target, setTarget] = useState<any>(null); // 관찰대상 target
    const [isLoaded, setIsLoaded] = useState(false); // Load 중인가를 판별하는 boolean
    const [stop, setStop] = useState(false); // 마지막 데이터까지 다 불러온 경우 더이상 요청을 보내지 않기 위해서

    const [isCalendar, setIsCalendar] = useState<boolean>(false);
    const [isVisibleSort, setIsVisibleSort] = useState<boolean>(false);
    const [isDetailModal, setIsDetailModal] = useState<boolean>(false);

    const [prevFilterFlag, setPrevFilterFlag] = useState<boolean>(false);
    const [isChangeFilter, setIsChangeFilter] = useState<boolean>(false);

    const [selectVideoId, setSelectVideoId] = useState<string>('');
    const [videoList, setVideoList] = useState<any>([]);
    const [isVideoModal, setIsVideoModal] = useState<boolean>(false);

    const [pictureList, setPictureList] = useState<any>([]);
    const [initialMediaIndex, setInitialMediaIndex] = useState<number>(0);
    const [isImageModal, setIsImageModal] = useState<boolean>(false);

    const [viewMode, setViewMode] = useState<'card' | 'table'>('card');
    const [currentFeedIndex, setCurrentFeedIndex] = useState<number>(0);

    // iOS iPad 감지 함수
    const isIOSiPad = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isIPad = /ipad/.test(userAgent);
        const isIOS = /iphone|ipad|ipod/.test(userAgent);
        return isIPad || (isIOS && window.innerWidth >= 768);
    };

    const toggleDropDown = () => {
        setIsVisibleSort(!isVisibleSort);
    };
    const handleDropDownSelect = (option: any) => {
        setSortType(option);
        setIsVisibleSort(false);
    };
    const onClickCalendar = () => {
        setIsCalendar(!isCalendar);
    };

    const onClickRefresh = () => {
        setLastPostId('');
        setPrevFilterFlag(isChangeFilter);
        setIsChangeFilter(!isChangeFilter);
        setStop(false);
    };

    // 전체선택 버튼 클릭이벤트
    const onClickAllButton = () => {
        navigate('/feed');
    };
    // 전체보기 버튼
    const onClickDetail = (object: any, index?: number) => {
        setIsDetailModal(true);
        setModalObject(object);
        if (index !== undefined) setCurrentFeedIndex(index);
    };
    // Drawer 내 네비게이션
    const onNavigateFeed = (index: number) => {
        if (feedList && index >= 0 && index < feedList.length) {
            setModalObject(feedList[index]);
            setCurrentFeedIndex(index);
        }
    };
    // Drawer에서 추가 데이터 로드
    const onLoadMoreFeeds = () => {
        if (!stop && feedList && feedList.length > 0) {
            setIsLoaded(true);
        }
    };
    // 뷰 모드 토글
    const onToggleViewMode = () => {
        setViewMode(viewMode === 'card' ? 'table' : 'card');
    };
    // 필터초기화
    const onClickClearFilter = () => {
        // setPrevFilterFlag(isChangeFilter);
        // setIsChangeFilter(!isChangeFilter);
        // setSortType({ value: 'all', label: '전체 보기' });
        // setStartDate(null);
        // setEndDate(null);
        // setCoachId('');
        // setLastPostId('');
        navigate('/feed');
    };
    // 강사 선택
    const onClickCoach = (coachId: string) => {
        navigate('/feed', {
            state: {
                coachId,
            },
        });
    };
    // 회원 선택
    const onClickMember = (memberData: any) => {
        setMemberId(memberData.memberId);
    };
    // 통합 피드 — PT + 그룹 수업일지 함께 조회 (GROUP_SESSION_LOG 포함)
    const centerId = authObject?.centerId ?? getItemWithExpiration('authObject')?.centerId;
    const feedStartDate = startDate ? dayjs(startDate).startOf('day').format('YYYY-MM-DD HH:mm') : undefined;
    const feedEndDate = endDate ? dayjs(endDate).endOf('day').format('YYYY-MM-DD HH:mm') : undefined;
    const userListStartTime = startDate ? dayjs(startDate).startOf('day').toISOString() : '';
    const userListEndTime = endDate ? dayjs(endDate).endOf('day').toISOString() : '';
    const getSpecificMemberFeedList = useQuery(
        ['getUnifiedMemberFeedAPI', centerId, memberId, sortType.value, feedStartDate, feedEndDate, isChangeFilter, lastPostId],
        async () =>
            await getUnifiedMemberFeedAPI(
                centerId,
                memberId,
                {
                    cursor: lastPostId || undefined,
                    limit: limitCount,
                    startDate: feedStartDate,
                    endDate: feedEndDate,
                    sort: sortType.value as any,
                },
                authorization,
            ),
        {
            onSuccess: (res) => {
                if (res?.status === 200) {
                    const nextPosts = res.data?.posts ?? [];
                    if (isChangeFilter === prevFilterFlag) {
                        setFeedList((prevData: any) =>
                            prevData ? [...prevData, ...nextPosts] : nextPosts,
                        );
                    } else {
                        setFeedList(nextPosts);
                    }
                    // hasMore=false면 추가 호출 차단
                    if (res.data?.hasMore === false) setStop(true);
                    setPrevFilterFlag(isChangeFilter);
                    setIsLoaded(false);
                }
            },
            onError: (err) => {
                console.log(err);
            },
            enabled: !!authorization && !!!authObject?.testAccount && !!memberId && !!centerId,
            staleTime: 0,
        }
    );
    //  센터 유저 리스트 조회 API : (GET)
    const getAllCoachMemberList = useQuery(
        ['getAllCoachMemberListAPI', authObject?.adminId, userListStartTime, userListEndTime],
        async () =>
            await getAllCoachMemberListAPI(
                authObject?.adminId,
                userListStartTime,
                userListEndTime,
                authorization
            ),
        {
            onSuccess: (res) => {
                if (res.status === 200) {
                    setCenterUserList(res.data.centerUserList);
                }
            },
            onError: (err) => {
                console.log(err);
            },
            enabled: !!authorization && !!!authObject?.testAccount,
            staleTime: 0,
        }
    );

    useEffect(() => {
        if (centerId || startDate || endDate || sortType.value || memberId) {
            setFeedList([]);
            setLastPostId('');
            setPrevFilterFlag(isChangeFilter);
            setIsChangeFilter(!isChangeFilter);
            setStop(false);
        }
    }, [centerId, startDate, endDate, sortType.value, memberId]);

    // 인피니티 스크롤 감지 함수
    const onIntersect = async ([entry]: any, observer: any) => {
        if (entry.isIntersecting && !isLoaded) {
            await observer.unobserve(entry.target);
            setIsLoaded(true);
            await observer.observe(entry.target);
        }
    };

    // isLoaded가 변할 때 실행 → 다음 페이지 로드
    useEffect(() => {
        if (isLoaded && !stop && feedList) {
            if (feedList && feedList.length > 0 && feedList.length % 10 === 0) {
                setLastPostId(feedList[feedList.length - 1]?._id);
                return;
            } else {
                return;
            }
        }
    }, [isLoaded]);

    // IntersectionObserver 설정
    useEffect(() => {
        let observer: any;
        if (target && !stop) {
            observer = new IntersectionObserver(onIntersect, {
                threshold: 0,
            });
            observer.observe(target);
        }
        return () => observer && observer.disconnect();
    }, [target, isLoaded]);

    // 상세 모달안 이미지/비디오 클릭 이벤트 (통합)
    const onClickImageAtDetailModal = (arr: any, clickedIndex?: number) => {
        setPictureList(arr);
        setInitialMediaIndex(clickedIndex || 0);
        setIsImageModal(true);
    };

    // 상세 모달안 비디오 클릭 이벤트
    const onClickVideoAtDetailModal = (arr: any, videoId: string) => {
        setSelectVideoId(videoId);
        setVideoList(arr);
        setIsVideoModal(true);
    };

    return (
        <Col
            style={{
                marginTop: 64,
                alignItems: 'center',
            }}
        >
            <Col style={{ width: 1192, marginTop: 48 }}>
                <FeedMemberHeader
                    sortOptions={sortOptions}
                    sortType={sortType}
                    isVisibleSort={isVisibleSort}
                    toggleDropDown={toggleDropDown}
                    handleDropDownSelect={handleDropDownSelect}
                    onClickCalendar={onClickCalendar}
                    onClickRefresh={onClickRefresh}
                    startDate={startDate}
                    endDate={endDate}
                    onClickClearFilter={onClickClearFilter}
                    viewMode={viewMode}
                    onToggleViewMode={onToggleViewMode}
                />

                <Row style={{ justifyContent: 'space-between', marginTop: 32 }}>
                    {/* 게시물 피드리스트 or 테이블 뷰 */}
                    {viewMode === 'card' ? (
                        <FeedList onClickDetail={onClickDetail} feedList={feedList} setTarget={setTarget} />
                    ) : (
                        <FeedTableView feedList={feedList} onClickDetail={onClickDetail} setTarget={setTarget} selectedIndex={isDetailModal ? currentFeedIndex : undefined} />
                    )}
                    {/* 센터 유저리스트 */}
                    <FeedSelectList
                        coachId={coachId}
                        memberId={memberId}
                        centerUserList={centerUserList}
                        onClickCoach={onClickCoach}
                        onClickMember={onClickMember}
                        onClickAllButton={onClickAllButton}
                    />
                </Row>
            </Col>

            {isCalendar && (
                <RangeCalendar
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    setIsCalendar={setIsCalendar}
                    isPrevMonth={true}
                    isNextMonth={true}
                />
            )}

            {/* 피드 상세 모달 */}
            {isDetailModal && (
                <ModalFeedDetail
                    modalObject={modalObject}
                    setModalVisible={setIsDetailModal}
                    onClickImageAtDetailModal={onClickImageAtDetailModal}
                    onClickVideoAtDetailModal={onClickVideoAtDetailModal}
                    isIOSiPad={isIOSiPad}
                    isConditionModal={false}
                    isImageModal={isImageModal}
                    isVideoModal={isVideoModal}
                    feedList={feedList}
                    currentIndex={currentFeedIndex}
                    onNavigate={onNavigateFeed}
                    onLoadMore={onLoadMoreFeeds}
                    canLoadMore={!stop}
                />
            )}
            {/* 이미지 뷰어 모달 */}
            {isImageModal && pictureList && (
                <ModalImagesViewer setModalVisible={setIsImageModal} pictureList={pictureList} initialIndex={initialMediaIndex} />
            )}

            {/* 비디오 플레이어 모달 */}
            {isVideoModal && videoList && selectVideoId && (
                <ModalVideoPlayer
                    setModalVisible={setIsVideoModal}
                    videoList={videoList}
                    selectVideoId={selectVideoId}
                    isIOSiPad={isIOSiPad}
                />
            )}

            {/* 사업자 정보 (카드사 심사용) */}
            <div style={{ width: '100%', marginTop: 40 }}>
                <BusinessInfoFooter />
            </div>
        </Col>
    );
};

export default FeedMemberPage;
